export default __webpack_public_path__ + "static/media/shield.c1918bcc.png";